/* AVA carrousel mobile - phase 2
 * Mobile uniquement (max-width:749px) : appui maintenu sur une carte produit = 2e image (dos/vue secondaire),
 * relâchement = retour 1re image SANS naviguer ; tap rapide = ouvre la fiche ; swipe horizontal = laisse la grille défiler.
 * Réutilise les images déjà dans le DOM (aucune injection).
 *  - variant-grid (t-shirts) UNIQUEMENT : classe .is-peeking sur .vg-card (CSS révèle .vg-card__img--secondary)
 *  - casquettes / tote bags (product-list) : exclues (pas de 2e image fiable dans le DOM — lazy/hidden)
 * Desktop strictement inchangé (les handlers sortent immédiatement si !mq.matches).
 */
(function () {
  if (window.__avaPeek) return;
  window.__avaPeek = true;

  var mq = window.matchMedia('(max-width: 749px)');
  var HOLD_MS = 100; // au-delà = appui maintenu (peek) ; en deçà = tap
  var MOVE_PX = 10;  // au-delà = swipe/scroll (on n'intercepte pas)

  // Uniquement variant-grid (t-shirts) : la 2e image y est un <img> prêt (.vg-card__img--secondary).
  // Les casquettes / tote bags (product-list) sont volontairement exclues (pas de 2e image fiable dans le DOM).
  function showSecond(card) { card.classList.add('is-peeking'); }
  function hideSecond(card) { card.classList.remove('is-peeking'); }

  function bind(card) {
    if (card.__avaPeekBound) return;
    card.__avaPeekBound = true;

    var startX = 0, startY = 0, moved = false, peeking = false, holdTimer = null, suppressClick = false;

    function clearHold() { if (holdTimer) { clearTimeout(holdTimer); holdTimer = null; } }

    card.addEventListener('touchstart', function (e) {
      if (!mq.matches) return; // desktop : aucun changement
      var t = e.touches[0];
      startX = t.clientX; startY = t.clientY;
      moved = false; peeking = false; suppressClick = false;
      clearHold();
      holdTimer = setTimeout(function () {
        if (!moved) { peeking = true; showSecond(card); }
      }, HOLD_MS);
    }, { passive: true });

    card.addEventListener('touchmove', function (e) {
      if (!mq.matches) return;
      var t = e.touches[0];
      if (Math.abs(t.clientX - startX) > MOVE_PX || Math.abs(t.clientY - startY) > MOVE_PX) {
        moved = true;
        clearHold();
        if (peeking) { hideSecond(card); peeking = false; }
      }
    }, { passive: true }); // jamais de preventDefault ici -> le swipe de grille (Phase 1) fonctionne

    card.addEventListener('touchend', function (e) {
      if (!mq.matches) return;
      clearHold();
      if (peeking) {
        hideSecond(card);
        peeking = false;
        suppressClick = true; // c'était un maintien -> on bloque la navigation
        e.preventDefault();
      }
      // tap rapide (ni peeking ni moved) : on ne fait rien -> le lien ouvre la fiche
    }, { passive: false }); // non passive : preventDefault autorisé

    card.addEventListener('touchcancel', function () {
      clearHold();
      if (peeking) { hideSecond(card); peeking = false; }
    }, { passive: true });

    // Ceinture + bretelles : annule le click synthétique qui suit un maintien
    card.addEventListener('click', function (e) {
      if (suppressClick) { e.preventDefault(); e.stopPropagation(); suppressClick = false; }
    }, true); // capture : avant la navigation du lien
  }

  function init() {
    var cards = document.querySelectorAll('.variant-grid__list .vg-card');
    for (var i = 0; i < cards.length; i++) bind(cards[i]);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  // Re-bind si une section est re-rendue (éditeur de thème, changement de variante...)
  document.addEventListener('shopify:section:load', init);
})();
